var _defs, _rect, _polygon, _path, _rect2, _rect3, _rect4, _rect5, _polygon2, _polygon3, _polygon4, _polygon5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7a9ac;}.cls-2{fill:#2eabe2;}.cls-3{fill:#231f20;stroke:#a7a9ac;stroke-miterlimit:10;stroke-width:0.25px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.63,
    y: 86.34,
    width: 4.74,
    height: 6.53
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.78 68.78 45.22 68.78 46.47 68.16 53.53 68.16 54.78 68.78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.34,15.47H46.52V4.83a7.09,7.09,0,0,1,6.82,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.52,
    y: 15.89,
    width: 6.82,
    height: 1.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.52,
    y: 18.24,
    width: 6.96,
    height: 11.28
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.52,
    y: 42.18,
    width: 6.96,
    height: 19.36
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.03,
    y: 75.39,
    width: 5.95,
    height: 11.17
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.54 36.14 46.46 36.14 45.22 29.52 54.78 29.52 53.54 36.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.54 68.16 46.46 68.16 45.22 61.54 54.78 61.54 53.54 68.16"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.54 75.39 46.46 75.39 45.22 68.78 54.78 68.78 53.54 75.39"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.46 36.14 53.54 36.14 54.78 42.76 45.22 42.76 46.46 36.14"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93,
    x2: 51.9,
    y2: 93
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93.14,
    x2: 51.9,
    y2: 93.14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93.29,
    x2: 51.9,
    y2: 93.29
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93.43,
    x2: 51.9,
    y2: 93.43
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93.58,
    x2: 51.9,
    y2: 93.58
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93.72,
    x2: 51.9,
    y2: 93.72
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 93.87,
    x2: 51.9,
    y2: 93.87
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.01,
    x2: 51.9,
    y2: 94.01
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.16,
    x2: 51.9,
    y2: 94.16
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.3,
    x2: 51.9,
    y2: 94.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.45,
    x2: 51.9,
    y2: 94.45
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.59,
    x2: 51.9,
    y2: 94.59
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.74,
    x2: 51.9,
    y2: 94.74
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 94.88,
    x2: 51.9,
    y2: 94.88
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.03,
    x2: 51.9,
    y2: 95.03
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.17,
    x2: 51.9,
    y2: 95.17
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.32,
    x2: 51.9,
    y2: 95.32
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.46,
    x2: 51.9,
    y2: 95.46
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.61,
    x2: 51.9,
    y2: 95.61
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.75,
    x2: 51.9,
    y2: 95.75
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 95.9,
    x2: 51.9,
    y2: 95.9
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.1,
    y1: 96.04,
    x2: 51.9,
    y2: 96.04
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/Service.6af8514de4742b6f6841a2bbc269dac8.svg";
export { ForwardRef as ReactComponent };